import { StaffActivityManagement } from "@/components/StaffActivityManagement";

export default function StaffActivityPage() {
  return <StaffActivityManagement />;
}
